export * from "./depthRenderer.pure";

import "../Shaders/depth.fragment";
import "../Shaders/depth.vertex";
import "../ShadersWGSL/depth.fragment";
import "../ShadersWGSL/depth.vertex";
